import {
  Alert,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  IconButton,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  styled,
  tableCellClasses,
} from "@mui/material";
import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { DmsPart } from "../../../models/features/ShoppingPortal/DmsPart";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  capitalizeFirstLetter,
  handleCartButtonAction,
  handleGetPartPrice,
} from "../../../services/utilities/utility";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import { image } from "html2canvas/dist/types/css/types/image";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

declare const emergepay: any;
interface PartsListProps {
  parts: DmsPart[];
  isLoadingParts: boolean;
  totalRecords: number;
  fetchMoreData: any;
  handleAddToCart: any;
}

export const PartsList: React.FunctionComponent<PartsListProps> = ({
  parts,
  isLoadingParts,
  totalRecords,
  fetchMoreData,
  handleAddToCart,
}) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  let partView = urlSearchParams.get("view");
  const rules = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting.settingRules
  );

  const cart = useSelector(
    (state: AppState) => state.shoppingPortalReducer.cart
  );
  const isExistsInCart = (id: string) => {
    return cart.some((item) => item.inventoryPartId === id);
  };

  const [viewMode, setViewMode] = React.useState(
    partView !== null ? partView : "list"
  ); // Default to grid view

  const handleToggleView = (mode: any) => {
    setViewMode(mode);
  };
  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabContext value={"Parts"}>
          {/* <TabList aria-label="lab API tabs example">
              <Tab label={"Parts"} value={"Parts"} />
            </TabList> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 2,
            }}
          >
            <IconButton
              onClick={() => handleToggleView("grid")}
              color={viewMode === "grid" ? "primary" : "default"}
            >
              <ViewModuleIcon />
            </IconButton>
            <IconButton
              onClick={() => handleToggleView("list")}
              color={viewMode === "list" ? "primary" : "default"}
            >
              <ViewListIcon />
            </IconButton>
          </Box>
          <TabPanel value="Parts" style={{ padding: 0 }}>
            <TableContainer
              sx={{
                maxHeight: "70vh",
                padding: "5px",
              }}
              component={Paper}
              id="table-scrollable"
            >
              <InfiniteScroll
                dataLength={parts.length}
                next={fetchMoreData}
                hasMore={parts.length < totalRecords}
                scrollThreshold={0.96}
                scrollableTarget="table-scrollable"
                loader={false}
              >
                {viewMode === "list" ? (
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            color: "#1976d2",
                            padding: 1.5,
                          }}
                          align="left"
                        >
                          Part Number
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: "bold",
                            color: "#1976d2",
                            padding: 1.5,
                          }}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: "bold",
                            color: "#1976d2",
                            padding: 1.5,
                          }}
                        >
                          Manufacturer
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            fontWeight: "bold",
                            color: "#1976d2",
                            padding: 1.5,
                          }}
                        >
                          Price($)
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: "bold",
                            color: "#1976d2",
                            padding: 1.5,
                          }}
                        >
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {parts?.length > 0 ? (
                        <>
                          {parts.map((item: any, index: number) => (
                            <StyledTableRow
                              hover
                              sx={{ ":hover": "black" }}
                              key={index}
                            >
                              <StyledTableCell
                                sx={{ padding: 1.5, fontSize: "12px" }}
                                align="left"
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                  }}
                                >
                                  {item?.partNumber}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ padding: 1.5, fontSize: "12px" }}
                                align="left"
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                  }}
                                >
                                  {item?.description}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ padding: 1.5, fontSize: "12px" }}
                                align="left"
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                  }}
                                >
                                  {item?.mfrName}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ padding: 1.5, fontSize: "12px" }}
                                align="right"
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                  }}
                                >
                                  {handleGetPartPrice(item, rules)}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ padding: 1.5 }}
                                align="center"
                              >
                                {(() => {
                                  const { hideButton, tooltipText } =
                                    handleCartButtonAction(item, rules);
                                  return hideButton ? (
                                    <IconButton size="small">
                                      <Tooltip title={tooltipText}>
                                        <RemoveShoppingCartIcon />
                                      </Tooltip>
                                    </IconButton>
                                  ) : (
                                    <Button
                                      sx={{ fontSize: "0.7125rem" }}
                                      size="small"
                                      variant="contained"
                                      disabled={
                                        isExistsInCart(item?.inventoryPartId) ||
                                        !(item.availableQty > 0) ||
                                        !(item.price > 0)
                                      }
                                      color="warning"
                                      onClick={() => {
                                        handleAddToCart(item);
                                      }}
                                    >
                                      {item.availableQty > 0
                                        ? "Add to Cart"
                                        : "Sold Out"}
                                    </Button>
                                  );
                                })()}
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </>
                      ) : (
                        <StyledTableRow>
                          {!isLoadingParts ? (
                            <StyledTableCell
                              sx={{ padding: 1.5 }}
                              align="center"
                              colSpan={6}
                            >
                              No Rows to show
                            </StyledTableCell>
                          ) : (
                            <></>
                          )}
                        </StyledTableRow>
                      )}
                      {isLoadingParts ? (
                        <StyledTableCell
                          sx={{ padding: 1.5 }}
                          align="center"
                          colSpan={6}
                        >
                          <h4>Loading...</h4>
                        </StyledTableCell>
                      ) : (
                        <></>
                      )}
                    </TableBody>
                  </Table>
                ) : (
                  <>
                    <Grid container spacing={3}>
                      {parts?.length > 0 ? (
                        parts.map((item: any, index: number) => (
                          <>
                            <Grid item md={3}>
                              {/* <Card sx={{ maxWidth: 345 }}>
                                  <Box
                                    sx={{
                                      height: 120,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      backgroundColor: "#f6f6f7",
                                    }}
                                  >
                                    <Typography color="white">
                                      {capitalizeFirstLetter(item.partNumber)}
                                    </Typography>
                                  </Box>

                                  <CardContent>
                                    <Typography
                                      gutterBottom
                                      component="div"
                                      style={{ transform: "none" }}
                                    >
                                      {capitalizeFirstLetter(item.description)}
                                    </Typography>
                                  </CardContent>
                                  <CardActionArea>
                                    <Button
                                      sx={{ fontSize: "0.7125rem" }}
                                      size="small"
                                      variant="contained"
                                      disabled={isExistsInCart(
                                        item?.inventoryPartId
                                      )}
                                      color="warning"
                                      onClick={() => {
                                        handleAddToCart(item);
                                      }}
                                    >
                                      Add to Cart
                                    </Button>
                                  </CardActionArea>
                                </Card> */}

                              <Card
                                sx={{ maxWidth: 345, position: "relative" }}
                              >
                                <CardMedia>
                                  {item.availableQty > 0 ? (
                                    <></>
                                  ) : (
                                    <SoldOutOverlay>SOLD OUT</SoldOutOverlay>
                                  )}

                                  <NoImage>
                                    {capitalizeFirstLetter(item.partNumber)}
                                  </NoImage>
                                </CardMedia>
                                <CardContent>
                                  <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {capitalizeFirstLetter(item.description)}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    color="textSecondary"
                                  >
                                    {capitalizeFirstLetter(item.mfrName)}
                                  </Typography>
                                  <Typography
                                    component="div"
                                    style={{ fontSize: "1rem" }}
                                  >
                                    ${handleGetPartPrice(item, rules)} USD
                                  </Typography>
                                  <Button
                                    variant="contained"
                                    color="warning"
                                    fullWidth
                                    sx={{ marginTop: 2 }}
                                    size="small"
                                    onClick={() => {
                                      handleAddToCart(item);
                                    }}
                                    disabled={
                                      isExistsInCart(item?.inventoryPartId) ||
                                      !(item.availableQty > 0) ||
                                      !(item.price > 0)
                                    }
                                  >
                                    {item.availableQty > 0
                                      ? "Add to Cart"
                                      : "Sold Out"}
                                  </Button>
                                </CardContent>
                              </Card>
                            </Grid>
                          </>
                        ))
                      ) : (
                        <></>
                      )}
                    </Grid>
                    {isLoadingParts ? (
                      <Typography
                        component={"h4"}
                        sx={{ padding: 1.5, paddingTop: 3, fontWeight: "bold" }}
                        align="center"
                      >
                        Loading...
                      </Typography>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </InfiniteScroll>
            </TableContainer>

            {!isLoadingParts && parts?.length === 0 && (
              <TableContainer component={Paper}>
                <Alert severity="info">No Records Found.</Alert>
              </TableContainer>
            )}
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};

export const searchOptions = {
  types: ["address"],
};

const SoldOutOverlay = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  backgroundColor: "black",
  color: "white",
  padding: "4px 8px",
  fontSize: "12px",
});

const NoImage = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "150px",
  backgroundColor: "#f0f0f0",
  color: "#000",
  fontSize: "20px",
});
